import views from '../views'

export default [
    {
        name: 'drawPage',
        path: '/:ercode',
        component: views.luckDraw.drawPage,
        meta: {
            title:""
        }
    },
    {
        name: 'result',
        path: '/luckDraw/result',
        component: views.luckDraw.result,
        meta: {
            title:"抽奖结果"
        }
    },
    {
        name: 'demo',
        path: '/luckDraw/demo',
        component: views.luckDraw.demo,
        meta: {
            title:"demo"
        }
    },
    {
        path: '/luckDraw/fakePage',
        name: 'fakePage',
        component: views.luckDraw.fakePage,
        meta: {
            title:"fakePage"
        }
    },
]



// WEBPACK FOOTER //
// ./src/router/luckDraw.js